import React from "react";
import { Navigate, useParams } from "react-router-dom";

//app
import MyProfilePage from "../features/nemonto/pages/my-profile-page";
import UserPrivacySetting from "../views/dashboard/app/user-privacy-setting";
import FriendProfilePage from "../features/nemonto/pages/friend-profile-page";
import ProfileBadges from "../views/dashboard/app/profile-badges";
import ProfileForums from "../views/dashboard/app/profile-forum";
import Notification from "../views/dashboard/app/notification";
import File from "../views/dashboard/app/file";
import FriendRequest from "../views/dashboard/app/friend-request";
import PeopleYouMayKnow from "../views/dashboard/app/people-you-may-know";
import BlockedFollower from "../views/dashboard/app/blocked-follower";
import Todo from "../views/dashboard/app/todo";
import UserAccountSetting from "../views/dashboard/app/user-account-setting";
import UserProfileEdit from "../views/dashboard/app/user-profile-edit";

// icon
import Remixicon from "../views/dashboard/icons/icon-remixicon";
import Lineawesome from "../views/dashboard/icons/icon-lineawesome";
import Fontawesome from "../views/dashboard/icons/icon-fontawesome-5";
import Material from "../views/dashboard/icons/icon-material";

// Form
import FormElement from "../views/dashboard/from/form-element";
import FormValidation from "../views/dashboard/from/form-validation";
import FormSwitch from "../views/dashboard/from/form-switch";
import FormWizard from "../views/dashboard/from/form-wizard";
import FormWizardValidate from "../views/dashboard/from/form-wizard-validate";
import FormWizardVertical from "../views/dashboard/from/form-wizard-vertical";
import FormCheckbox from "../views/dashboard/from/form-checkbox";
import FormRadio from "../views/dashboard/from/form-radio";

// table
import DataTable from "../views/dashboard/table/data-table";
import TableBasic from "../views/dashboard/table/tables-basic";
import TableEditable from "../views/dashboard/table/table-editable";

// Email
import Email from "../views/dashboard/email/email";
import EmailCompose from "../views/dashboard/email/email-compose";

//ui-kit
import UiAlerts from "../views/dashboard/ui-kit/ui-alerts";
import UiBadges from "../views/dashboard/ui-kit/ui-badges";
import UiBreadcrumbs from "../views/dashboard/ui-kit/ui-breadcrumb";
import UiButtons from "../views/dashboard/ui-kit/ui-buttons";
import UiCards from "../views/dashboard/ui-kit/ui-cards";
import UiCarousels from "../views/dashboard/ui-kit/ui-carousel";
import UiColors from "../views/dashboard/ui-kit/ui-color";
import UiDropdowns from "../views/dashboard/ui-kit/ui-dropdowns";
import UiEmbedVideos from "../views/dashboard/ui-kit/ui-embed-video";
import UiGrids from "../views/dashboard/ui-kit/ui-grid";
import UiImages from "../views/dashboard/ui-kit/ui-images";
import UiListGroups from "../views/dashboard/ui-kit/ui-list-groups";
import UiModals from "../views/dashboard/ui-kit/ui-modal";
import UiNotifications from "../views/dashboard/ui-kit/ui-notifications";
import UiOffcanvas from "../views/dashboard/ui-kit/ui-offcanvas";
import UiPaginations from "../views/dashboard/ui-kit/ui-pagination";
import UiPopovers from "../views/dashboard/ui-kit/ui-popovers";
import UiProgressbars from "../views/dashboard/ui-kit/ui-progressbars";
import UiTabs from "../views/dashboard/ui-kit/ui-tabs";
import UiTooltips from "../views/dashboard/ui-kit/ui-tooltips";
import UiTypographys from "../views/dashboard/ui-kit/ui-typography";

// extrapages
import Pricing from "../views/extrapages/pricing";
import Pricing1 from "../views/extrapages/pricing1";
import Timeline from "../views/extrapages/timeline";
import Invoice from "../views/extrapages/invoice";
import Faq from "../views/extrapages/faq";
import AboutUs from "../views/extrapages/about-us";
import PrivacyPolicy from "../views/extrapages/privacy-policy";
import TermsofUse from "../views/extrapages/terms-of-use";
import BlankPage from "../views/extrapages/blankpage";
import ContactUs from "../views/extrapages/contact/contact-us";

import Admin from "../views/dashboard/app/admin";
import TeachersHelper from "../views/dashboard/ai/teachers-helper";
import TeachersHelperList from "../views/dashboard/ai/teachers-helper-list";
import TeachersHelperDetails from "../views/dashboard/ai/teachers-helper-details";
import ActivityList from "../views/dashboard/ai/activity-list";
import DailyReports from "../views/dashboard/app/daily-reports";
import AllergyActionPlanList from "../views/dashboard/app/allergy-action-plan/allergy-action-plan-list";
import AllergyActionPlanForm from "../views/dashboard/app/allergy-action-plan/allergy-action-plan-form";
import LunchPlanWaiverList from "../views/dashboard/app/lunch-plan-waiver/lunch-plan-waiver-list";
import LunchPlanWaiverForm from "../views/dashboard/app/lunch-plan-waiver/lunch-plan-waiver-form";
import NoPeanutPolicyList from "../views/dashboard/app/no-peanut-policy/no-peanut-policy-list";
import NoPeanutPolicyForm from "../views/dashboard/app/no-peanut-policy/no-peanut-policy-form";
import EmergencyContactList from "../views/dashboard/app/emergency-contact/emergency-contact-list";
import EmergencyContactForm from "../views/dashboard/app/emergency-contact/emergency-contact-form";
import ChildRegistrationList from "../views/dashboard/app/child-registration/child-registration-list";
import ChildRegistrationForm from "../views/dashboard/app/child-registration/child-registration-form";
import LeaveApplication from "../views/dashboard/app/leave-application";

// The old feedDetails page was retired in favor of the nemonto-themed
// recipe detail screen (/pages/recipe/:id) - this keeps old links/bookmarks
// (and any deep-linked notification) working.
const FeedDetailsRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/pages/recipe/${slug}`} replace />;
};

// The old Bootstrap-themed challenge details page has been retired in
// favor of the nemonto-styled /pages/challenge/:id screen - this keeps old
// links/bookmarks (and deep-linked notifications) working.
const ChallengeDetailsRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/pages/challenge/${slug}`} replace />;
};

export const DefaultRouter = [
  {
    // Retired: this old generic feed page has been replaced by the
    // nemonto-styled /pages/home. Kept as a redirect for old links/bookmarks.
    path: "dashboard/app/news-feed",
    element: <Navigate to="/pages/home" replace />,
  },
  {
    path: "dashboard/app/profile",
    element: <MyProfilePage />,
  },
  {
    path: "dashboard/app/user-privacy-setting",
    element: <UserPrivacySetting />,
  },
  {
    // The old friend-profile wrapper (views/dashboard/app/friend-profile.js)
    // did its own now-unused PROFILE_DETAILS fetch and a queued
    // window.scrollTo({behavior:"smooth"}) before ultimately just rendering
    // this same nemonto-styled page with no props - that redundant work was
    // making the "view profile" navigation from a post feel janky/slow.
    // Route straight to the real page instead (it reads :slug itself).
    path: "dashboard/app/friend-profile/:slug",
    element: <FriendProfilePage />,
  },
  {
    path: "dashboard/app/feedDetails/:slug",
    element: <FeedDetailsRedirect />,
  },
  {
    path: "dashboard/app/challengeDetails/:slug",
    element: <ChallengeDetailsRedirect />,
  },
  {
    path: "dashboard/app/profile-badges",
    element: <ProfileBadges />,
  },
  {
    path: "dashboard/app/profile-forum",
    element: <ProfileForums />,
  },
  {
    path: "dashboard/app/notification",
    element: <Notification />,
  },
  {
    path: "dashboard/app/file",
    element: <File />,
  },
  {
    path: "dashboard/app/friend-request",
    element: <FriendRequest />,
  },
  {
    path: "dashboard/app/people-you-may-know",
    element: <PeopleYouMayKnow />,
  },
  {
    path: "dashboard/app/blocked-follower",
    element: <BlockedFollower />,
  },
  {
    path: "dashboard/app/todo",
    element: <Todo />,
  },
  {
    path: "dashboard/app/user-account-setting",
    element: <UserAccountSetting />,
  },
  {
    path: "dashboard/app/user-profile-edit",
    element: <UserProfileEdit />,
  },
  {
    path: "dashboard/icon/fontawesome-5",
    element: <Fontawesome />,
  },
  {
    path: "dashboard/icon/remixicon",
    element: <Remixicon />,
  },
  {
    path: "dashboard/icon/lineawesome",
    element: <Lineawesome />,
  },
  {
    path: "dashboard/icon/material",
    element: <Material />,
  },
  {
    path: "dashboard/form/form-elemen",
    element: <FormElement />,
  },
  {
    path: "dashboard/form/form-validation",
    element: <FormValidation />,
  },
  {
    path: "dashboard/form/form-switch",
    element: <FormSwitch />,
  },
  {
    path: "dashboard/form/form-wizard",
    element: <FormWizard />,
  },
  {
    path: "dashboard/form/form-wizard-validate",
    element: <FormWizardValidate />,
  },
  {
    path: "dashboard/form/form-wizard-vertical",
    element: <FormWizardVertical />,
  },
  {
    path: "dashboard/form/form-checkbox",
    element: <FormCheckbox />,
  },
  {
    path: "dashboard/form/form-radio",
    element: <FormRadio />,
  },
  {
    path: "dashboard/Email/email",
    element: <Email />,
  },
  {
    path: "dashboard/Email/email-compose",
    element: <EmailCompose />,
  },
  {
    path: "dashboard/extrapages/pages-pricing",
    element: <Pricing />,
  },
  {
    path: "dashboard/extrapages/pages-pricing-one",
    element: <Pricing1 />,
  },
  {
    path: "dashboard/extrapages/pages-timeline",
    element: <Timeline />,
  },
  {
    path: "dashboard/extrapages/pages-invoice",
    element: <Invoice />,
  },
  {
    path: "dashboard/extrapages/pages-faq",
    element: <Faq />,
  },
  {
    path: "about-us",
    element: <AboutUs />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "terms-of-use",
    element: <TermsofUse />,
  },
  {
    path: "contact-us",
    element: <ContactUs />,
  },
  {
    path: "blankpage",
    element: <BlankPage />,
  },
  {
    path: "dashboard/app/admin",
    element: <Admin />,
  },
  // Ui-kit
  {
    path: "dashboard/ui-kit/ui-alerts",
    element: <UiAlerts />,
  },
  {
    path: "dashboard/ui-kit/ui-badges",
    element: <UiBadges />,
  },
  {
    path: "dashboard/ui-kit/ui-breadcrumb",
    element: <UiBreadcrumbs />,
  },
  {
    path: "dashboard/ui-kit/ui-buttons",
    element: <UiButtons />,
  },
  {
    path: "dashboard/ui-kit/ui-cards",
    element: <UiCards />,
  },
  {
    path: "dashboard/ui-kit/ui-carousel",
    element: <UiCarousels />,
  },
  {
    path: "dashboard/ui-kit/ui-color",
    element: <UiColors />,
  },
  {
    path: "dashboard/ui-kit/ui-dropdowns",
    element: <UiDropdowns />,
  },
  {
    path: "dashboard/ui-kit/ui-embed-video",
    element: <UiEmbedVideos />,
  },
  {
    path: "dashboard/ui-kit/ui-grid",
    element: <UiGrids />,
  },
  {
    path: "dashboard/ui-kit/ui-images",
    element: <UiImages />,
  },
  {
    path: "dashboard/ui-kit/ui-list-groups",
    element: <UiListGroups />,
  },
  {
    path: "dashboard/ui-kit/ui-modal",
    element: <UiModals />,
  },
  {
    path: "dashboard/ui-kit/ui-notifications",
    element: <UiNotifications />,
  },
  {
    path: "dashboard/ui-kit/ui-offcanvas",
    element: <UiOffcanvas />,
  },
  {
    path: "dashboard/ui-kit/ui-pagination",
    element: <UiPaginations />,
  },
  {
    path: "dashboard/ui-kit/ui-popovers",
    element: <UiPopovers />,
  },
  {
    path: "dashboard/ui-kit/ui-progressbars",
    element: <UiProgressbars />,
  },
  {
    path: "dashboard/ui-kit/ui-tabs",
    element: <UiTabs />,
  },
  {
    path: "dashboard/ui-kit/ui-tooltips",
    element: <UiTooltips />,
  },
  {
    path: "dashboard/ui-kit/ui-typography",
    element: <UiTypographys />,
  },
  // Table
  {
    path: "dashboard/table/data-table",
    element: <DataTable />,
  },
  {
    path: "dashboard/table/tables-basic",
    element: <TableBasic />,
  },
  {
    path: "dashboard/table/table-editable",
    element: <TableEditable />,
  },
  // Form
  {
    path: "dashboard/form/form-element",
    element: <FormElement />,
  },
  {
    path: "dashboard/form/form-validation",
    element: <FormValidation />,
  },
  {
    path: "dashboard/form/form-switch",
    element: <FormSwitch />,
  },
  {
    path: "dashboard/form/form-wizard",
    element: <FormWizard />,
  },
  {
    path: "dashboard/form/form-wizard-validate",
    element: <FormWizardValidate />,
  },
  {
    path: "dashboard/form/form-wizard-vertical",
    element: <FormWizardVertical />,
  },
  {
    path: "dashboard/form/form-checkbox",
    element: <FormCheckbox />,
  },
  {
    path: "dashboard/form/form-radio",
    element: <FormRadio />,
  },
  {
    path: "dashboard/app/teachers-helper",
    element: <TeachersHelper />,
  },
  {
    path: "dashboard/app/teachers-helper-list",
    element: <TeachersHelperList />,
  },
  {
    path: "dashboard/app/teachers-helper-details",
    element: <TeachersHelperDetails />,
  },
  {
    path: "dashboard/app/activity-list",
    element: <ActivityList />,
  },
  {
    path: "dashboard/daily-reports",
    element: <DailyReports />,
  },
  {
    path: "dashboard/allergy-action-plan/list",
    element: <AllergyActionPlanList />,
  },
  {
    path: "dashboard/allergy-action-plan/add",
    element: <AllergyActionPlanForm />,
  },
  {
    path: "dashboard/allergy-action-plan/edit/:id",
    element: <AllergyActionPlanForm />,
  },
  {
    path: "dashboard/child-registration/list",
    element: <ChildRegistrationList />,
  },
  {
    path: "dashboard/child-registration/add",
    element: <ChildRegistrationForm />,
  },
  {
    path: "dashboard/child-registration/edit/:id",
    element: <ChildRegistrationForm />,
  },
  {
    path: "dashboard/lunch-plan-waiver/list",
    element: <LunchPlanWaiverList />,
  },
  {
    path: "dashboard/lunch-plan-waiver/add",
    element: <LunchPlanWaiverForm />,
  },
  {
    path: "dashboard/lunch-plan-waiver/edit/:id",
    element: <LunchPlanWaiverForm />,
  },
  {
    path: "dashboard/no-peanut-policy/list",
    element: <NoPeanutPolicyList />,
  },
  {
    path: "dashboard/no-peanut-policy/add",
    element: <NoPeanutPolicyForm />,
  },
  {
    path: "dashboard/no-peanut-policy/edit/:id",
    element: <NoPeanutPolicyForm />,
  },
  {
    path: "dashboard/emergency-contact/list",
    element: <EmergencyContactList />,
  },
  {
    path: "dashboard/emergency-contact/add",
    element: <EmergencyContactForm />,
  },
  {
    path: "dashboard/emergency-contact/edit/:id",
    element: <EmergencyContactForm />,
  },
  {
    path: "dashboard/app/leave-application",
    element: <LeaveApplication />,
  }
];
